module.exports = __webpack_public_path__ + "static/media/shout-light.d744be09.png";